import * as React from "react";
import { graphql } from "gatsby";

//style imports
import "./index.scss";

//components imports
import HcpLayout from "../components/layout";
import FluidContent from "../components/fluidContent";
import Button from "../components/button";
import VideoAbs from "../components/videoAbsolute";
import heroVideo from "../images/hero-video.mp4";
import { StaticImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-grid-system";
import CardArticle from "../components/cards/cardArticle";
import { MyPortableText } from "../components/myPortableText";
import AOS from "aos";
import "aos/dist/aos.css";
import { Seo } from "../components/seo";
import bannerThumbnail from "../images/video-tumbnail.webp";
import { format } from "date-fns";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardPodcasts from "../components/cards/cardPodcasts";
// import whiteImg from "../images/home/aphexda-white-logo.png";
//import newsFeed from "../libs/newslist";

const axios = require("axios");

const articlesAndPodcasts = [
  {
    title: 'PharmaVoice: Flipping a biotech incubator into a commercial company',
    link: 'https://www.pharmavoice.com/spons/flipping-a-biotech-incubator-into-a-commercial-company/715872/',
    type: 'article',
  },
  {
    title: 'Industry Dive Podcast Series: The Power of Persistence - From Biotech Incubator to Product Launch',
    link: 'https://www.biopharmadive.com/spons/podcast-the-power-of-persistence-from-biotech-incubator-to-product-launc/717534/',
    type: 'podcast',
  }
]

const IndexPage = (props) => {
  const pageData = props.data.sanityHomepage;
  const [pressReleases, setPressReleases] = React.useState([]);
  const [itemsToShow, setItemsToShow] = React.useState(3);
  // console.log(pageData);

  const slides = pageData._rawHomepageSlider ?? [];
  //check developer tools for the object return
  // console.log(slides);

  const getPressReleases = async () => {
    try {
      // const responseRaw = await axios.get(
      //   "https://clientapi.gcs-web.com/data/9d8f997c-0f79-45e7-8adc-1bd5b9d26331/News?type=general|earnings"
      // );

      const blobResponse = await axios.get(
        "https://biolinerxweb.blob.core.windows.net/biolinerswebpr/pressReleases.json"
      );

      //console.log("blobResponse,", blobResponse);
      //console.log(response.data.data);
      //console.log("newsFeed,", newsFeed);
      const response = blobResponse.data.data;
      const topThreePR = response ? response.slice(0, 3) : [];
      //console.log(topThreePR);
      setPressReleases(topThreePR);
    } catch (e) {
      console.error(e);
    }
  };

  var CardSlider = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 15000,
    infinite: true,
    arrows: false,
    speed: 1000,
    adaptiveHeight: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  React.useEffect(() => {
    AOS.init({
      offset: 50,
      duration: 1000,
      easing: "ease",
    });

    AOS.refresh();
    getPressReleases();
    setTimeout(function () {
      AOS.init();
    }, 1000);
  }, []);

  return (
    <HcpLayout pageClass="homepage">
      <FluidContent className="hero-wrapper">
        <div className="hero-banner banner video-abs">
          <VideoAbs
            videoSrc={heroVideo}
            thumbnail={bannerThumbnail}
            thumbnailAlt="Colorful lines moving from left to right in a looped animation"
          />
          <div className="centered-content">
            <div className="banner-content">
              <div data-aos="fade-up">
                <MyPortableText value={pageData?._rawPageTitle} />
              </div>

              <div className="card-discover desktop-only">
                <Slider {...CardSlider} className="card-discover-slider">
                  {slides.map((item) => (
                    <div className="two-col-card slider-item" key={item._id}>
                      <Row className="row" justify="between">
                        {item.blockImage && (
                          <Col lg={5.5}>
                            <div className="media">
                              <img
                                src={item?.blockImage?.asset.url}
                                alt={item?.blockImage?.blockImageAltText}
                                loading="lazy"
                              />
                            </div>
                          </Col>
                        )}
                        <Col lg={item.blockImage ? 6.3 : 12}>
                          <div className="info">
                            {item?.blockTitle && (
                              <span className="head">{item?.blockTitle}</span>
                            )}
                            <MyPortableText value={item.text} />
                            <div
                              className={`btn-wrap ${item.blockImage ? "" : "no-image"
                                }`}
                            >
                              <Button
                                to={item?.button?.url}
                                className="btn-tertiary has-icon-right"
                                external={false}
                              >
                                {item?.button?.caption}
                                <FontAwesomeIcon icon={faArrowRight} />
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
        <div className="card-discover__wrap mobile-only">
          <div className="centered-content">
            <div className="card-discover">
              <Slider {...CardSlider} className="card-discover-slider">
                {slides.map((item) => {
                  return (
                    <div className="two-col-card slider-item" key={item._id}>
                      <Row className="row" justify="between">
                        {item.blockImage && (
                          <Col lg={5.5}>
                            <div className="media">
                              <img
                                src={item?.blockImageMobile?.asset.url}
                                alt={
                                  item?.blockImageMobile
                                    ?.blockImageMobileAltText
                                }
                                loading="lazy"
                              />
                            </div>
                          </Col>
                        )}
                        <Col lg={item.blockImage ? 6.3 : 12}>
                          <div className="info">
                            {item?.blockTitle && (
                              <span className="head">{item?.blockTitle}</span>
                            )}
                            <MyPortableText value={item.text} />
                            <div className="btn-wrap">
                              <Button
                                to={item?.button?.url}
                                className="btn-tertiary has-icon-right"
                                external={false}
                              >
                                {item?.button?.caption}
                                <FontAwesomeIcon icon={faArrowRight} />
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </FluidContent>

      <FluidContent className="about-block">
        <div className="centered-content">
          <div className="about-content info-wrap" data-aos="fade-up">
            <h4>{pageData?._rawBlocks[1]?.blockTitle}</h4>
            <MyPortableText value={pageData?._rawBlocks[1].text} />
            <div className="btn-wrap">
              <Button
                to={pageData?._rawBlocks[1]?.button?.url}
                className="btn-primary has-icon-right"
                external={false}
              >
                {pageData?._rawBlocks[1]?.button?.caption}
                <FontAwesomeIcon icon={faArrowRight} />
              </Button>
            </div>
          </div>
        </div>
      </FluidContent>

      <FluidContent className="partnership-block">
        <StaticImage
          style={{ position: "absolute" }}
          class="partnership-block__media desktop"
          src="../images/home/partnership-bg.webp"
          alt="abstract teal ball moving on blue wave segments"
          width={1440}
          height={844}
          quality={100}
        />
        <StaticImage
          style={{ position: "absolute" }}
          class="partnership-block__media mobile"
          src="../images/home/img-home-partnerships_mobile.webp"
          alt="abstract teal ball moving on blue wave segments"
          width={750}
          height={1456}
          quality={100}
        />
        <div className="centered-content">
          <div className="partnership-content" data-aos="fade-up">
            <h4>{pageData?._rawBlocks[2]?.blockTitle}</h4>
            <MyPortableText value={pageData?._rawBlocks[2].text} />
            <div className="btn-wrap">
              <Button
                to={pageData?._rawBlocks[2]?.button?.url}
                className="btn-tertiary has-icon-right"
                external={false}
              >
                {pageData?._rawBlocks[2]?.button?.caption}
                <FontAwesomeIcon icon={faArrowRight} />
              </Button>
            </div>
          </div>
        </div>
      </FluidContent>

      <FluidContent className="news-block">
        <div className="centered-content">
          <div className="news-block__content">
            <Row className="row" justify="between">
              <Col lg={5} xl={4}>
                <div className="info-wrap" data-aos="fade-up">
                  <h4>{pageData?._rawNewsBlock?.blockTitle}</h4>
                  <div className="btn-wrap desktop-only">
                    <Button
                      to={pageData?._rawNewsBlock?.button?.url}
                      className="btn-primary has-icon-right"
                      external={false}
                    >
                      {pageData?._rawNewsBlock?.button?.caption}
                      <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                  </div>
                </div>
              </Col>
              <Col lg={7} xl={7.25}>
                <div className="news-wrap" data-aos="fade-up">
                  {pressReleases.length > 0 &&
                    pressReleases.map((item) => (
                      <CardArticle
                        key={item?.id}
                        newsLink={item?.link.hostedUrl}
                        newsTitle={item?.title}
                        newsType="Press Release"
                        postedDate={format(
                          new Date(item?.releaseDate.dateUTC),
                          "dd-MMM-yyyy"
                        )}
                      />
                    ))}

                  <div className="btn-wrap mobile-only">
                    <Button
                      to={pageData?._rawNewsBlock?.button?.url}
                      className="btn-primary has-icon-right"
                      external={false}
                    >
                      {pageData?._rawNewsBlock?.button?.caption}
                      <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </FluidContent>
      <FluidContent className="featured-content-block">
        <div className="centered-content">
          <div className="featured-content-block__content">
            <Row className="row" justify="between">
              <Col lg={5} xl={4}>
                <div className="info-wrap" data-aos="fade-up">
                  <h4>Featured Content: Articles & Podcasts</h4>
                </div>
              </Col>
              <Col lg={7} xl={7.25}>
                <div className="article-wrap" data-aos="fade-up">
                  {articlesAndPodcasts.slice(0, itemsToShow).map((item, index) => (
                    <CardPodcasts
                      title={item.title}
                      key={item.title + index}
                      btnTitle={item.type === 'podcast' ? 'Listen' : 'Read Article'}
                      url={item.link}
                    />
                  ))}
                </div>
                {articlesAndPodcasts.length > itemsToShow &&
                  <button
                    onClick={() => setItemsToShow(itemsToShow + 3)}
                    className='btn-load'
                  >
                    Load more <span className="icon">+</span>
                  </button>}
              </Col>
            </Row>
          </div>
        </div>
      </FluidContent>

      <FluidContent className="careers-block video-abs">
        <StaticImage
          className="right-curved desktop-only"
          src="../images/top-right-white-curved.png"
          alt="White Curve shaped"
          placeholder="none"
          quality={100}
        />
        <div className="centered-content">
          <div className="careers-block__content info-wrap" data-aos="fade-up">
            <h4>{pageData?._rawBlocks[3]?.blockTitle}</h4>
            <MyPortableText value={pageData?._rawBlocks[3].text} />
            <div className="btn-wrap">
              <Button
                to={pageData?._rawBlocks[3]?.button?.url}
                className="btn-tertiary has-icon-right"
                external={false}
              >
                {pageData?._rawBlocks[3]?.button?.caption}
                <FontAwesomeIcon icon={faArrowRight} />
              </Button>
            </div>
          </div>
        </div>
      </FluidContent>
    </HcpLayout>
  );
};
export default IndexPage;

export const Head = () => (
  <Seo
    title="BioLineRx | Driving innovative therapeutics across the finish line"
    description="BioLineRx is building a best-in-class pipeline designed to deliver meaningful therapeutic benefit to patients with certain cancers and rare diseases."
  />
);

// graphql Page Data
// http://localhost:8000/___graphql
export const query = graphql`
  {
    sanityHomepage {
      pageName
      _rawPageTitle(resolveReferences: { maxDepth: 10 })
      _rawHomepageSlider(resolveReferences: { maxDepth: 10 })
      _rawBlocks(resolveReferences: { maxDepth: 10 })
      _rawNewsBlock(resolveReferences: { maxDepth: 10 })
    }
  }
`;
